import { ContentType } from '../../../models/enums';
import { convertInlineElementsToContentModels, decoupleReference, getBlockModelById, getSelectedRange, setCursorPosition } from '../../../common/utils/index';
import * as constants from '../../../common/constant';
import { BlockFactory } from '../../../block-manager/services/block-factory';
import { events } from '../../../common/constant';
export class InlineContentInsertionModule {
    constructor(manager) {
        this.parent = manager;
        this.addEventListeners();
    }
    addEventListeners() {
        this.parent.observer.on('inlineContentInsertion', this.handleInlineContentInsertion, this);
        this.parent.observer.on(events.destroy, this.destroy, this);
    }
    removeEventListeners() {
        this.parent.observer.off('inlineContentInsertion', this.handleInlineContentInsertion);
        this.parent.observer.off(events.destroy, this.destroy);
    }
    handleInlineContentInsertion(args) {
        const contentType = (args.value.toString().indexOf('e-user-mention-item-template')) > 0
            ? ContentType.Mention
            : ContentType.Label;
        const options = {
            block: getBlockModelById(this.parent.currentFocusedBlock.id, this.parent.getEditorBlocks()),
            blockElement: this.parent.currentFocusedBlock,
            range: getSelectedRange().cloneRange(),
            contentType: contentType,
            itemData: args.itemData,
            mentionChar: contentType === ContentType.Mention ? '@' : this.parent.labelSettings.triggerChar
        };
        this.processInsertion(options);
    }
    processInsertion(options) {
        const { range, contentType, blockElement, mentionChar } = options;
        if (!range || !blockElement) {
            return;
        }
        const rangeParent = this.getRangeParent(range);
        const insertedNode = this.findInsertedNode(contentType, rangeParent);
        // Remove the trigger char from the block model first
        this.parent.mentionAction.removeMentionQueryKeysFromModel(mentionChar);
        // Split the DOM and update model
        this.splitAndReorganizeContent(insertedNode, contentType, rangeParent, options);
    }
    splitAndReorganizeContent(insertedNode, contentType, rangeParent, options) {
        const { block } = options;
        const blockContentElement = rangeParent.closest('.' + constants.CONTENT_CLS);
        if (!blockContentElement || !insertedNode) {
            return null;
        }
        const oldBlock = decoupleReference(block);
        const isCurrBlkEmpty = blockContentElement.textContent === '';
        const insertedContent = this.createInlineContentModel(insertedNode, contentType, options);
        // DOM Update
        const newInlineNode = this.parent.blockRenderer.contentRenderer.invokeContentRenderer(block, insertedContent);
        insertedNode.replaceWith(newInlineNode);
        // Normalize empty nodes
        const validNodes = [...Array.from(blockContentElement.childNodes)].filter((n) => n.textContent.trim());
        const isAtEnd = validNodes.indexOf(newInlineNode) === validNodes.length - 1;
        if (!isAtEnd && !isCurrBlkEmpty) {
            blockContentElement.normalize();
        }
        // Model update
        const newContents = convertInlineElementsToContentModels(blockContentElement, true);
        this.parent.blockService.updateContent(block.id, newContents);
        this.parent.stateManager.updateManagerBlocks();
        this.parent.observer.notify('modelChanged', { type: 'ReRenderBlockContent', state: {
                data: [{ block: block, oldBlock: oldBlock }],
                excludeDomUpdate: true
            } });
        this.parent.undoRedoAction.trackContentChangedForUndoRedo(oldBlock, decoupleReference(block));
        /* Utilize suffix node appended by mention control for cursor, if null-create and append */
        let nextSibling = newInlineNode.nextSibling;
        if (!nextSibling) {
            nextSibling = document.createTextNode('');
            newInlineNode.parentNode.appendChild(nextSibling);
        }
        setCursorPosition(nextSibling, 0);
    }
    createInlineContentModel(element, contentType, options) {
        const user = options.itemData;
        const labelItem = options.itemData;
        const contentValue = contentType === ContentType.Mention ? user.user : element.innerText;
        let newContent;
        if (contentType === ContentType.Mention) {
            newContent = BlockFactory.createMentionContent({ content: contentValue }, { userId: user.id });
        }
        else if (contentType === ContentType.Label) {
            newContent = BlockFactory.createLabelContent({ content: contentValue }, { labelId: labelItem.id });
        }
        return newContent;
    }
    getRangeParent(range) {
        return range.startContainer.nodeType === Node.TEXT_NODE
            ? range.startContainer.parentElement
            : range.startContainer;
    }
    findInsertedNode(contentType, rangeParent) {
        const contentClassMap = {
            [ContentType.Mention]: 'e-mention-chip',
            [ContentType.Label]: 'e-mention-chip'
        };
        return rangeParent.querySelector(`span[class='${contentClassMap[`${contentType}`]}`);
    }
    /**
     * Destroys the inline content module.
     *
     * @returns {void}
     */
    destroy() {
        this.removeEventListeners();
    }
}
